import client from "@/api/client"
import { createMutation } from "react-query-kit"

export const useMutateAddFcmToken = createMutation({
  mutationFn: ({ token }: { token: string }) => client.api.userControllerAddNotificationToken({ token }),
})
